import { Buffer3384y49aj0pxr as Buffer } from './Buffer.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var RealBufferedSinkClass;
function RealBufferedSink() {
  if (RealBufferedSinkClass === VOID) {
    class $ {
      constructor(sink) {
        this.d3z_1 = sink;
        this.e3z_1 = false;
        this.f3z_1 = new (Buffer())();
      }
      u3u(source, byteCount) {
        // Inline function 'okio.internal.commonWrite' call
        // Inline function 'kotlin.check' call
        if (!!this.e3z_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.f3z_1.u3u(source, byteCount);
        this.g3z();
        return Unit_instance;
      }
      k3y(byteString) {
        // Inline function 'okio.internal.commonWrite' call
        // Inline function 'kotlin.check' call
        if (!!this.e3z_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.f3z_1.k3y(byteString);
        return this.g3z();
      }
      m3y(string) {
        // Inline function 'okio.internal.commonWriteUtf8' call
        // Inline function 'kotlin.check' call
        if (!!this.e3z_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.f3z_1.m3y(string);
        return this.g3z();
      }
      n3y(string, beginIndex, endIndex) {
        // Inline function 'okio.internal.commonWriteUtf8' call
        // Inline function 'kotlin.check' call
        if (!!this.e3z_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.f3z_1.n3y(string, beginIndex, endIndex);
        return this.g3z();
      }
      o3y(b) {
        // Inline function 'okio.internal.commonWriteByte' call
        // Inline function 'kotlin.check' call
        if (!!this.e3z_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.f3z_1.o3y(b);
        return this.g3z();
      }
      g3z() {
        // Inline function 'okio.internal.commonEmitCompleteSegments' call
        // Inline function 'kotlin.check' call
        if (!!this.e3z_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        var byteCount = this.f3z_1.v3x();
        if (byteCount > 0n) {
          this.d3z_1.u3u(this.f3z_1, byteCount);
        }
        return this;
      }
      lc() {
        // Inline function 'okio.internal.commonFlush' call
        // Inline function 'kotlin.check' call
        if (!!this.e3z_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        if (this.f3z_1.w3u_1 > 0n) {
          this.d3z_1.u3u(this.f3z_1, this.f3z_1.w3u_1);
        }
        this.d3z_1.lc();
        return Unit_instance;
      }
      l6() {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonClose' call
          if (this.e3z_1) {
            tmp$ret$0 = Unit_instance;
            break $l$block;
          }
          var thrown = null;
          try {
            if (this.f3z_1.w3u_1 > 0n) {
              this.d3z_1.u3u(this.f3z_1, this.f3z_1.w3u_1);
            }
          } catch ($p) {
            if ($p instanceof Error) {
              var e = $p;
              thrown = e;
            } else {
              throw $p;
            }
          }
          try {
            this.d3z_1.l6();
          } catch ($p) {
            if ($p instanceof Error) {
              var e_0 = $p;
              if (thrown == null)
                thrown = e_0;
            } else {
              throw $p;
            }
          }
          this.e3z_1 = true;
          if (!(thrown == null))
            throw thrown;
          tmp$ret$0 = Unit_instance;
        }
        return tmp$ret$0;
      }
      toString() {
        // Inline function 'okio.internal.commonToString' call
        return 'buffer(' + toString(this.d3z_1) + ')';
      }
    }
    initMetadataForClass($, 'RealBufferedSink');
    RealBufferedSinkClass = $;
  }
  return RealBufferedSinkClass;
}
//region block: exports
export {
  RealBufferedSink as RealBufferedSinkipqv3pv5gqfq,
};
//endregion

//# sourceMappingURL=RealBufferedSink.mjs.map
